import { NoteDef } from 'types/note/note.def';

export const noteDeftoTableMyResultData = (notes: NoteDef) => {
  return {
    legends: [
      'Note "commerciale" (chiffre d\'affaires)',
      'Note "respect des consignes" (ventes additionnelles)',
      'Note "connaissances" (quiz)',
      'Note "curiosité professionnelle" (ventes B to B)',
      'Note "implication" (nombre de ventes)',
      'Note Challenge'
    ],
    me: [
      'Moi',
      notes.cavente + ' / 20',
      notes.venterebond + ' / 20',
      notes.quiz + ' / 20',
      notes.pro + ' / 20',
      notes.nbvente + ' / 20',
      notes.moyennegenerale + ' / 20'
    ]
  };
};
